import React from "react";
import cn from "../../lib/cn";
import P from "../typography/P";

const Info = ({ className, message }) => {
    return (
        <div className={cn(className)}>
            <P className="border border-blue bg-blue/10  text-blue py-1 text-center rounded-2 my-1">
                {message}
            </P>
        </div>
    );
};

export default Info;
